module.exports = __webpack_public_path__ + "static/media/PJ small_1580326682832.8ad0ea52.png";